export default __webpack_public_path__ + "static/jaroslav-suchy-706aa56940d8ea85992c3b25981cb06e.jpg";